import FlightTicketCard from "pages/report/flight/ticketComponents/FlightTicketCard";
import React, { useEffect, useRef, useState } from "react";

const FlightTicketPrint = (props) => {
    const printTimeoutRef = useRef(null);

    useEffect(() => {
        if (props.execPrint && props.printDom && props.printContent && props.printStyles) {
            if (printTimeoutRef.current) {
                clearTimeout(printTimeoutRef.current);
            }
            
            const doc = props.printDom.document;
            doc.open();
            
            doc.write(`
                <!DOCTYPE html>
                <html>
                    <head>
                        <meta charset="utf-8">
                        <title>Print Ticket</title>
                        <style>
                            @media print {
                                body {
                                    -webkit-print-color-adjust: exact;
                                    print-color-adjust: exact;
                                }
                                @page {
                                    size: A4;
                                    margin: 20px;
                                }

                                .page-break {
                                    page-break-before: always;
                                    break-before: page;
                                }
                                    
                                .no-break {
                                    page-break-inside: avoid;
                                    break-inside: avoid;
                                }

                                .ticket-itin-row .itin-baggage-col {
                                    margin: 10px 0;
                                }
                            }
                            ${props.printStyles}
                        </style>
                    </head>
                    <body>
                        <div id="print-content">
                            ${props.printContent}
                        </div>
                    </body>
                </html>
            `);
            doc.close();

            const waitForPrint = () => {
                if (doc.readyState === 'complete') {
                    printTimeoutRef.current = setTimeout(() => {
                        try {
                            props.printDom.focus();
                            props.printDom.print();
                            props.setExecPrint(false);
                        } catch (error) {
                            console.error('Print error:', error);
                        }
                    }, 2000);
                } else {
                    setTimeout(waitForPrint, 100);
                }
            };

            waitForPrint();
        }

        return () => {
            if (printTimeoutRef.current) {
                clearTimeout(printTimeoutRef.current);
            }
        };
    }, [props.execPrint, props.printDom, props.printContent, props.printStyles]);

    return (
        <div style={{ width: '210mm', margin: '0 auto' }}>
            <FlightTicketCard
                data={props.data}
                state={props.state}
                markup={props.markup}
                isStatusLoading={props.isStatusLoading}
                appconst={props.appconst}
            />
        </div>
    );
};

export default FlightTicketPrint;
